module.exports = __webpack_public_path__ + "static/media/exclamation-purple.4111d4a9.svg";